"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../Types");
var react_router_dom_1 = require("react-router-dom");
var components_1 = require("@athena-portal/components");
var SupportPortalTemplates_1 = require("../../SupportPortalTemplates");
var Page_1 = require("../Page");
var operators_1 = require("rxjs/operators");
var DocumentWithContent_1 = require("../../model/DocumentWithContent");
var Document_1 = require("../../model/Document");
var commonFunctions_1 = require("../../helpers/commonFunctions");
var Tree_1 = require("../../components/Tree");
var CommunicationsTree = /** @class */ (function (_super) {
    __extends(CommunicationsTree, _super);
    function CommunicationsTree(props) {
        var _this = _super.call(this, props) || this;
        _this.supportPortalTemplates = new SupportPortalTemplates_1.SupportPortalTemplates;
        _this.renderUploadDocumentLink = function () {
            return ((0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "freetext-file-input-" + _this.props.interactionId, children: (0, jsx_runtime_1.jsx)("div", { className: "d-block text-primary on-hover-underline cursor-pointer", children: "Upload document" }) }), (0, jsx_runtime_1.jsx)("input", { type: "file", id: "freetext-file-input-" + _this.props.interactionId, accept: ".pdf", className: "d-none", onChange: function (e) { return _this.uploadCommunication(e); } }), _this.state.invalidCommunicationUploaded && (0, jsx_runtime_1.jsx)("p", { className: "color-red", children: "This file already uploaded." })] }) }));
        };
        _this.downloadDocument = function (doc) { return function (event) {
            _this.context.loadingQueue.increment(function () {
                _this.supportPortalService
                    .downloadDocument(doc.id)
                    .pipe((0, operators_1.finalize)(_this.context.loadingQueue.decrement))
                    .subscribe(function (documentContent) {
                    if (documentContent) {
                        var link = document.createElement("a");
                        var blob = new Blob([documentContent]);
                        var blobUrl = URL.createObjectURL(blob);
                        document.body.appendChild(link);
                        link.download = doc.subject;
                        link.href = blobUrl;
                        link.click();
                        document.body.removeChild(link);
                    }
                });
            });
        }; };
        _this.state = {
            communications: _this.props.communications ? _this.props.communications : [],
            invalidCommunicationUploaded: false
        };
        return _this;
    }
    CommunicationsTree.prototype.render = function () {
        if (this.state.communications && this.state.communications.length > 0) {
            var communicationsTree = [];
            for (var _i = 0, _a = this.state.communications; _i < _a.length; _i++) {
                var communication = _a[_i];
                communicationsTree.push((0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("i", { className: "far fa-comment-dots" }), " ", this.getCommunicationSubject(communication), (0, jsx_runtime_1.jsx)("br", {})] }) }, communication.id));
            }
            return ((0, jsx_runtime_1.jsxs)(Tree_1.Tree, { label: "Communications [".concat(this.state.communications.length, "]"), children: [communicationsTree, this.renderUploadDocumentLink()] }));
        }
        return ((0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: "Communications [0]", children: this.renderUploadDocumentLink() }));
    };
    CommunicationsTree.prototype.uploadCommunication = function (event) {
        var _this = this;
        var file = event.target.files[0];
        var fileName = file.name;
        var invalidCommunicationUploaded = false;
        this.state.communications.forEach(function (communication) {
            if (communication.subject === fileName) {
                invalidCommunicationUploaded = true;
            }
            _this.setState({ invalidCommunicationUploaded: invalidCommunicationUploaded });
        });
        if (!invalidCommunicationUploaded) {
            var reader_1 = new FileReader;
            reader_1.readAsDataURL(file);
            reader_1.onload = function () {
                var documentWithContent = new DocumentWithContent_1.default();
                var content = reader_1.result;
                documentWithContent.content = content.replace("data:application/pdf;base64,", "");
                var document = new Document_1.default();
                document.name = (0, commonFunctions_1.capitalize)("FREETEXT_" + file.name);
                document.title = file.name;
                documentWithContent.document = document;
                _this.context.loadingQueue.increment(function () {
                    _this.supportPortalService
                        .uploadDocument(documentWithContent, _this.props.policyNumber, _this.props.policyVersionNumber, _this.props.process, _this.props.interactionId)
                        .pipe((0, operators_1.finalize)(_this.context.loadingQueue.decrement)).toPromise()
                        .then(function () {
                        if (_this.props.process === "renewal") {
                            _this.context.loadingQueue.increment(function () {
                                _this.supportPortalService
                                    .getRenewalCommunications(_this.props.policyNumber, _this.props.policyVersionNumber)
                                    .pipe((0, operators_1.finalize)(_this.context.loadingQueue.decrement))
                                    .subscribe(function (communications) {
                                    _this.setState({ communications: communications });
                                });
                            });
                        }
                        else {
                            _this.context.loadingQueue.increment(function () {
                                _this.supportPortalService
                                    .getCommunications(_this.props.policyNumber, _this.props.policyVersionNumber)
                                    .pipe((0, operators_1.finalize)(_this.context.loadingQueue.decrement))
                                    .subscribe(function (communications) {
                                    _this.setState({ communications: communications });
                                });
                            });
                        }
                    });
                });
            };
        }
    };
    CommunicationsTree.prototype.getCommunicationSubject = function (communication) {
        if (this.supportPortalTemplates.userHasRole(["Administrator", "Claims_Handler", "Fraud", "CSR_Lead", "CSR"])) {
            if (communication.contentType === 'PDF') {
                return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "#", onClick: this.downloadDocument(communication), children: "".concat(communication.subject) }), " [".concat(SupportPortalTemplates_1.SupportPortalTemplates.convertDateToUkTimeZoneDate(communication.sentDate), "]")] });
            }
            else {
                return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { target: "_blank", to: "/communications/".concat(communication.id), children: "".concat(communication.subject) }), " [".concat(SupportPortalTemplates_1.SupportPortalTemplates.convertDateToUkTimeZoneDate(communication.sentDate), "]")] });
            }
        }
        return communication.subject;
    };
    CommunicationsTree.contextType = Page_1.PageContext;
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], CommunicationsTree.prototype, "supportPortalService", void 0);
    CommunicationsTree = __decorate([
        components_1.authorize,
        (0, components_1.role)("Administrator", "Claims_Handler", "Fraud", "CSR_Lead", "CSR", "Support"),
        __metadata("design:paramtypes", [Object])
    ], CommunicationsTree);
    return CommunicationsTree;
}(React.Component));
exports.default = CommunicationsTree;
//# sourceMappingURL=CommunicationsTree.js.map